import React from "react";
import { processValue as processValueUtil } from "../../utils";
import { SelectWidgetProps } from "./models";
import { NativeSelectWidget } from "./NativeSelectWidget";
import { ReactSelectWidget } from "./ReactSelectWidget";

// Shared by both NativeSelectWidget and ReactSelectWidget

export const SelectWidgetComponent = <T extends string | number>(props: SelectWidgetProps<T>) => {
  const processValue = (value: any) => {
    const { schema, required } = props;

    return processValueUtil(value, schema.type, required) as T | null | undefined;
  };

  return props.options.renderType === "react-select" ? (
    <ReactSelectWidget {...props} processValue={processValue} />
  ) : (
    <NativeSelectWidget {...props} processValue={processValue} />
  );
};

export const SelectWidget = SelectWidgetComponent;
